import mergeOptions from 'merge-options'

function FetchClient (opts = {
    endpoint: '',
    fetchOptions: {}
}) {
    Object.keys(opts || {})
        .forEach(str => (this[str] = opts[str]))

    return this
}

FetchClient.prototype.setFetchOptions = function (
    fetchOptions = {}
) {
    this.fetchOptions = fetchOptions
    return this
}

FetchClient.prototype.request = function async (
    endpoint = '',
    fetchOptions = {}
) {
    const url = `${this.endpoint || ''}${endpoint}`

    const opts = mergeOptions(this.fetchOptions || {}, fetchOptions || {})

    if (opts.json)
        try {
            opts.body = JSON.stringify(opts.json)

            opts.headers = opts.headers || {}
            opts.headers['Content-Type'] = 'application/json'

            delete opts.json
        }
        catch (err) {
            console.warn(err)
        }

    return window.fetch(url, opts)
        .then(async (res) => {
            const contentType = res.headers.get('content-type') || ''

            const isContentType = (mimeType = '') => contentType
                .includes(mimeType)

            let method

            method = isContentType('text')
                && 'text'

            method = isContentType('json')
                && 'json'

            let data

            try {
                data = res[method]
                    && await res[method]()
            }
            catch (err) {
                console.warn(err)
            }

            return data || res
        })
}

FetchClient.prototype.requestMethods = [
    'get',
    'post',
    'put',
    'patch',
    'head',
    'delete'
]

FetchClient.prototype.requestMethods
    .forEach((method) =>
        (FetchClient.prototype[method] = function (
            endpoint = '',
            fetchOptions = {}
        ) {
            return this.request(endpoint, mergeOptions(fetchOptions || {}, {
                method: method
            }))
        }))

export const fetchClient = new FetchClient({
    endpoint: window.location.origin,
    fetchOptions: {
        method: 'POST',
        headers: {
            'x-hasura-role': 'anonymous'
        }
    }
})
